import { render, staticRenderFns } from "./LoadingLists.vue?vue&type=template&id=2a568b83&scoped=true&"
import script from "./LoadingLists.vue?vue&type=script&lang=js&"
export * from "./LoadingLists.vue?vue&type=script&lang=js&"
import style0 from "./LoadingLists.vue?vue&type=style&index=0&id=2a568b83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a568b83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
